/** API route map: URLS.Controller.CompanyGroup */
export const CompanyGroup = {
      Name: 'CompanyGroup/',
      Add: 'add',
      GetAll: 'get-all',
      Update: 'update',
      Delete: 'delete',
      GetGroupBranches: 'get-group-branches',
      GetUserBranches: 'get-user-group-branches',
};
